/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./j-skeleton.vue?vue&type=template&id=56545706&scoped=true"
import script from "./j-skeleton.vue?vue&type=script&lang=js"
export * from "./j-skeleton.vue?vue&type=script&lang=js"
import style0 from "./j-skeleton.vue?vue&type=style&index=0&id=56545706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56545706",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QSkeleton,QItem,QItemSection,QItemLabel,QCardActions,QMarkupTable});
